import React from 'react';
import styled from 'styled-components';

import scrollToTop from '../../../../../shared/utils/scrollToTop';

import {defaultTheme} from '@stencil/build-theme';
import HappyBackToTopIcon from '@stencil/icons/src/HappyBackToTopIcon/HappyBackToTopIcon';

const handleScrollToTop = () => {
  scrollToTop();
};

const BackToTopCard = () => (
  <WrapperDiv onClick={handleScrollToTop}>
    <WrapperSpan>
      <TextSpan>Back to Top</TextSpan>
    </WrapperSpan>
    <WrapperSpan>
      <ArrowUpIconWrapperSpan>
        <HappyBackToTopIcon fill={defaultTheme.colors.goBrandBlue.base} />
        {/* <Eicon className="icon-arrow-up" fontSize={font.ico8} color={color.white} /> */}
      </ArrowUpIconWrapperSpan>
    </WrapperSpan>
  </WrapperDiv>
);

export default BackToTopCard;

const WrapperDiv = styled.div(
  props => `
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  width: 100%;
  margin: 0 0 ${props.theme.spacing.base} 0;
  background-color: ${props.theme.colors.goWhite.base};
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  padding: ${props.theme.spacing.large};
  box-shadow: 0 ${props.theme.spacing.xsmall} ${props.theme.spacing.custom(4)} 0 ${
    props.theme.colors.shadow.light
  };
  align-items: center;
  justify-content: center;
`,
);

const WrapperSpan = styled.div(
  props => `
  display: inline-flex;
  cursor: pointer;
`,
);

const TextSpan = styled.span(
  props => `
  line-height: ${props.theme.font.lineHeight.base};

  font-size: ${props.theme.font.custom(16)};
  font-family: ${props.theme.font.fontFamily};
  font-weight: bold;
`,
);

const ArrowUpIconWrapperSpan = styled.span(
  props => `
  height: 1.6rem;
  width: 1.6rem;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  margin: ${props.theme.spacing.xsmall} 0 0 ${props.theme.spacing.small};
  font-size: ${props.theme.font.xsmall};
`,
);
